import React from "react";
import SeoTitle from "src/components/Shared/Text/SeoTitle";

const AuthLayout = ({ children, ...props }) => {
  return (
    <>
      <SeoTitle title={props?.site.name} />
      <div className="min-h-full flex flex-col justify-center py-12 px-2 sm:px-6 lg:px-8 w-full">{children}</div>
    </>
  );
};

export default AuthLayout;
